import { create } from "zustand";
import { ProcessResult } from "types/output_vu";
import { ProcessResultVh } from "types/output_vh";

type AnyProcessResult = ProcessResult | ProcessResultVh;

interface Notification {
  projectId: string;
  documentId: string;
  projectName: string;
  result: AnyProcessResult;
}

interface ErrorNotification {
  title: string;
  message: string;
  onRetry?: () => void;
  onCancel?: () => void;
}

interface NotificationState {
  notification: Notification | null;
  errorNotification: ErrorNotification | null;
  showNotification: (notification: Notification) => void;
  showErrorNotification: (error: ErrorNotification) => void;
  clearNotification: () => void;
  clearErrorNotification: () => void;
}

export const useNotificationStore = create<NotificationState>((set) => ({
  notification: null,
  errorNotification: null,
  showNotification: (notification) => {
    console.log("📢 NotificationStore: showNotification called with:", notification);
    set({ notification });
  },
  showErrorNotification: (errorNotification) => {
    console.log("📢 NotificationStore: showErrorNotification called with:", errorNotification);
    set({ errorNotification });
  },
  clearNotification: () => {
    console.log("📢 NotificationStore: clearNotification called");
    set({ notification: null });
  },
  clearErrorNotification: () => {
    console.log("📢 NotificationStore: clearErrorNotification called");
    set({ errorNotification: null });
  },
}));
